export default {"src":"/_next/static/media/Softtissuelumpsandcysts.19f4cbfc.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};